import { createAsyncThunk } from '@reduxjs/toolkit';
import type { AppDispatch } from '@store/types';
import { pushMessage } from '@reducers/v2/messagesBus/messagesBus.slice';
import { MachineMessageType } from '@reducers/v2/messagesBus/types';
import type { OnUpdatedMachineStatusSignalRResponse } from '@interfaces/machines';

export const machineStatusUpdatedMessageProducer = createAsyncThunk<void, OnUpdatedMachineStatusSignalRResponse, { dispatch: AppDispatch }>(
  'machines/machineStatusUpdatedMessageProducer',
  async (e, { dispatch }) => {
    const machineId = (e.machineStatus as { machineId?: number })?.machineId;
    if (machineId == null) return;

    dispatch(
      pushMessage({
        key: machineId,
        message: {
          messageType: MachineMessageType.MACHINE_STATUS_UPDATED,
          payload: e,
        },
      })
    );
  }
);
